import { combineReducers } from "redux";
import all_wallet_history from "../features/admin/all_wallet_history/slice";
import all_withdraw_request from "../features/admin/all_withdraw_request/slice";
import all_deposit_request from "../features/admin/all_deposit_request/slice";

const AllWalletHistoryData = combineReducers({
  all_wallet_history: all_wallet_history,
  all_withdraw_request: all_withdraw_request,
  all_deposit_request: all_deposit_request,
});

export default AllWalletHistoryData;
